import { styled } from '@mui/material';

const StyledColumn = styled('div')({
  background: '#FFF',
  padding: '0.9375rem',
  border: '0.0625rem solid #D6D6D6',
  marginBottom: '1.25rem',
  display: 'flex',
});

export default StyledColumn;
